// extracted by mini-css-extract-plugin
export default {"container":"approvals_container__mcnfL"};